import {
  Box,
  Button as MuiButton,
  IconButton,
  Link,
  Paper,
  Switch,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  TextField,
  Tooltip,
} from "@mui/material";
import React, { useState } from "react";
import styled from "@emotion/styled";
import { chiaveGaranzia, useFormAccordo } from "./ContextAccordo";
import { NumericFormat } from "react-number-format";
import { Add } from "@mui/icons-material";
import GaranzieModale from "./lib/GaranzieModale";
import DeleteIcon from "@mui/icons-material/Delete";
import ConfermaElimina from "./lib/ConfermaElimina";

const TableWrapper = styled.div`
  overflow-y: auto;
  max-width: calc(100vw - ${(props) => props.theme.spacing(12)});
`;

const Button = styled(MuiButton)`
  margin: 0 8px;
`;

const Garanzie = () => {
  const { formState, dispatch } = useFormAccordo();
  // Modale aggiungi/modifica: null = chiusa, { garanzia: null } = nuova,
  // { garanzia } = modifica di una garanzia esistente
  const [modale, setModale] = useState(null);
  // Chiave della garanzia da eliminare (null = modale chiusa)
  const [daEliminare, setDaEliminare] = useState(null);

  const deleteGaranzia = () => {
    dispatch({ type: "delete_garanzia", id: daEliminare });
    setDaEliminare(null);
  };
  /* console.log(formState); */
  return (
    <>
      <Box textAlign="end">
        <Tooltip title="Aggiungi garanzia">
          <Button
            variant="contained"
            onClick={() => setModale({ garanzia: null })}
          >
            <Add />
          </Button>
        </Tooltip>
      </Box>
      {modale !== null && (
        <GaranzieModale
          open
          setOpen={() => setModale(null)}
          garanzia={modale.garanzia}
        />
      )}
      {daEliminare !== null && (
        <ConfermaElimina
          open
          setOpen={() => setDaEliminare(null)}
          onConfirm={deleteGaranzia}
          type="garanzia"
        />
      )}
      <Paper sx={{ mt: 4 }}>
        <TableWrapper>
          <Table>
            <TableHead>
              <TableRow>
                <TableCell align="left">Garanzia / Accessorio</TableCell>
                <TableCell align="center">ID Code</TableCell>
                <TableCell align="center">Prezzo</TableCell>
                <TableCell align="center">Obbligatorio</TableCell>
                <TableCell align="center">Visibile</TableCell>
                <TableCell align="center">Frazionamento</TableCell>
                <TableCell align="center">Incluso</TableCell>
                <TableCell align="center">Garanzia Ratino</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {formState.garanzie.map((row) => (
                <TableRow key={chiaveGaranzia(row)}>
                  <TableCell>
                    <Box display="flex" alignItems="center" gap={2}>
                      <IconButton
                        onClick={() => setDaEliminare(chiaveGaranzia(row))}
                      >
                        <DeleteIcon color="error" />
                      </IconButton>
                      <Tooltip title="Modifica garanzia">
                        <Link
                          component="button"
                          underline="hover"
                          textAlign="left"
                          onClick={() => setModale({ garanzia: row })}
                          sx={{ width: 200, fontSize: "inherit" }}
                        >
                          {row.nome}
                        </Link>
                      </Tooltip>
                    </Box>
                  </TableCell>
                  <TableCell align="center">
                    <TextField
                      id={`${chiaveGaranzia(row)}LabelIdCode`}
                      sx={{ width: 140 }}
                      value={row.idCode ?? ""}
                      onChange={(e) =>
                        dispatch({
                          type: "set_garanzie",
                          id: chiaveGaranzia(row),
                          payload: {
                            ...row,
                            idCode: e.target.value,
                          },
                        })
                      }
                    />
                  </TableCell>
                  <TableCell align="center">
                    <NumericFormat
                      id={`${chiaveGaranzia(row)}LabelPrezzo`}
                      customInput={TextField}
                      prefix="€"
                      thousandSeparator="."
                      decimalSeparator=","
                      decimalScale={2}
                      sx={{ width: 100 }}
                      valueIsNumericString
                      value={row.prezzo}
                      onValueChange={(e) => {
                        console.log(e);
                        dispatch({
                          type: "set_garanzie",
                          id: chiaveGaranzia(row),
                          payload: {
                            ...row,
                            prezzo: e.value,
                          },
                        });
                      }}
                    />
                  </TableCell>
                  {[
                    "obbligatorio",
                    "visibile",
                    "frazionamento",
                    "incluso",
                    "garanziaRatino",
                  ].map((el) => (
                    <TableCell align="center" key={el}>
                      <Switch
                        id={`${chiaveGaranzia(row)}Label${el}`}
                        checked={row[el] === 1 ? true : false}
                        onChange={(e) =>
                          dispatch({
                            type: "set_garanzie",
                            id: chiaveGaranzia(row),
                            payload: {
                              ...row,
                              [el]: e.target.checked ? 1 : 0,
                            },
                          })
                        }
                        sx={{
                          "&.MuiSwitch-root .MuiSwitch-switchBase": {
                            color: "#ccc",
                          },
                          "&.MuiSwitch-root .Mui-checked": {
                            color: "#407ad6",
                          },
                        }}
                      />
                    </TableCell>
                  ))}
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableWrapper>
      </Paper>
    </>
  );
};

export default Garanzie;
